import { Fragment } from "react";
import type { ReactNode } from "react";

type LinkInjection = {
  label: string;
  element: ReactNode;
};

type Part = { key: string; node: ReactNode };

/**
 * Splits `description` on each link label (first occurrence only) and injects
 * the corresponding React element in-place. Labels must appear verbatim in the
 * description string — typically as CMS param placeholders like `{termsOfService}`.
 */
export function injectLinks(description: string, links: LinkInjection[]): ReactNode {
  let parts: Part[] = [{ key: "root", node: description }];

  for (const { label, element } of links) {
    parts = parts.flatMap((part) => {
      if (typeof part.node !== "string") return [part];
      const index = part.node.indexOf(label);
      if (index === -1) return [part];
      return [
        { key: `before:${label}`, node: part.node.slice(0, index) },
        { key: `link:${label}`, node: element },
        { key: `after:${label}`, node: part.node.slice(index + label.length) },
      ];
    });
  }

  return (
    <>
      {parts.map(({ key, node }) => (
        <Fragment key={key}>{node}</Fragment>
      ))}
    </>
  );
}
